/**
 * Created by miguel on 22/2/17.
 */


class DocumentListCell extends UITableViewCell
{
    protected documentIDLabel:MUILabel = null;
    protected referenceLabel:MUILabel = null; 
    protected totalLabel:MUILabel = null;

    protected cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter;

    awakeFromHTML(){
        this.documentIDLabel = MUIOutlet(this, "document-id-lbl", "MUILabel"); 
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");        
        this.totalLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
    }

    set item(item:DBDocument) { this.setItem(item); }

    setItem(item:DBDocument){
        this.documentIDLabel.text = item.documentNumber;
        this.referenceLabel.text = item.reference;
        if (this.totalLabel) this.totalLabel.text = this.cf.stringFromNumber(item.totalAmount);
    }

}